var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"unified-panel-body editor-body"},[_c('markdown-editor',{ref:"markdownEditor",attrs:{"initial-markdown":_vm.initialContent,"onupdate":_vm.onUpdate,"toolbar":true,"show-markdown-help":_vm.showMarkdownHelp}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }